import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { AppContext } from "../../../../Context/Context"; // Import AppContext

export const Plan = ({
    id,
    percentage,
    type,
    plan,
    grupo,
    orden,
    modelo,
    fechaIngreso,
    suscripcion,
    botonArrepentimiento
}) => {
    const history = useHistory();
    const [state, , setSelectedPlan] = useContext(AppContext); // Access setSelectedPlan from context

    let handlePlan = () => {
        if (botonArrepentimiento?.noPoint) {
            return;
        }

        const plan = state.planes.find(plan => plan.Id === id);
        if (plan) {
            setSelectedPlan(plan);
        } else {
            console.error("Selected plan not found.");
        }
    };

    const startsWith8 = suscripcion?.toString().startsWith("8");


    return (
        <div className="col-lg-6">
            <div className="seleccionPlan_mainDiv_plan">
                <a
                    onClick={handlePlan}
                    className={`main ${botonArrepentimiento?.noPoint && "no-point"}`}
                >
                    <div className="seleccionPlan_mainDiv_plan--title">
                        {type === "rescindido / renunciado" ? (
                            <div className="rojo">{type}</div>
                        ) : (
                            <div className="vino">{type}</div>
                        )}

                        {type !== "rescindido / renunciado" && !botonArrepentimiento?.noPoint && (
                            <img src="/images/icons/big-arrow-right.svg" />
                        )}
                    </div>
                    <h1>
                        {modelo} - {plan}
                    </h1>
                    {grupo && orden ? (
                        <>
                            <div className="seleccionPlan_mainDiv_plan--info">
                                <div>Ingreso: {fechaIngreso}</div>
                                <div>N° Suscripción: {suscripcion}</div>
                            </div>
                            <div className="seleccionPlan_Grupo_Orden">
                                <div className="pl-0 pr-0">Grupo: {grupo}</div>
                                <div className="col-6 pr-0">Orden: {orden}</div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="seleccionPlan_Grupo_Orden">
                                <div className="pl-0 pr-0">Sin Agrupar</div>
                                <br />
                                <br />
                            </div>
                        </>
                    )}
                </a>
                <div className="separator--hor mt-half mb-half"></div>
                <div className="seleccionPlan_mainDiv_plan--cuotas">
                    <p>Cuotas</p>
                    <div className="progress">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: percentage + "%" }}
                            aria-valuenow={percentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {percentage}%
                        </div>
                    </div>
                </div>
                {botonArrepentimiento?.plan?.BotonRENARRDisponible && startsWith8 && (
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn-form mt-half seleccion-plan"
                            onClick={() => {
                                botonArrepentimiento.handleOpen(botonArrepentimiento.plan);
                            }}
                        >
                            {botonArrepentimiento.plan.BotonRENARRTexto}
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                            />
                        </button>
                    </div>
                )}
                {botonArrepentimiento?.plan?.BotonRENARRDisponible && !startsWith8 && (
                    <div className="mt-half">
                        <p className="text-muted small">
                        Te solicitamos contactarte con tu concesionario para continuar con el proceso
                        </p>
                    </div>
                )}
                {type === "rescindido / renunciado" && (
                    <div className="seleccionPlan_mainDiv_plan--buttons">
                        <a
                            className="mb-half mr-lg-octa"
                            href="https://crmfcalatam.my.site.com/selfservicepda/s/leapmotor"
                        >
                            <img
                                className="mr-half"
                                src="/images/icons/atencion-al-cliente.svg"
                            />{" "}
                            ATENCIÓN AL CLIENTE{" "}
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                            />
                        </a>
                        <a
                            className="mt-half mt-lg-0 ml-lg-octa"
                            href="https://docs.google.com/forms/d/e/1FAIpQLScrbjDT23kNgbG3c6I90grTWc5q4H-yQwMBo2y5xo6vqLzoOw/viewform?gxids=7628"
                        >
                            SOLICITUD DE REINTEGRO
                            <img
                                className="ml-half arrow"
                                src="/images/icons/small.svg"
                            />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
